import React from 'react';
import { CheckCircle2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function HaritikaSection() {
  return (
    <section id="haritika" className="py-16 px-6 max-w-7xl mx-auto bg-white rounded-3xl border border-gray-200/80 my-10 shadow-sm">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        
        {/* Left Portrait Image Container */}
        <div className="lg:col-span-5 relative">
          <div className="aspect-[4/5] bg-[#EFECE6] rounded-3xl flex items-center justify-center border border-gray-300 relative overflow-hidden">
            {/* Local Image Rendered */}
            <img 
              src="/harritika.jpg (1).jpeg" 
              alt="Haritika - Trader, Investor & Financial Consultant" 
              className="w-full h-full object-cover object-top"
            />

            {/* Overlay Badges */}
            <div className="absolute top-4 left-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-xl shadow-md border border-gray-200 z-10">
              <span className="text-xs font-bold text-[#D97706] block">3 certifications</span>
              <span className="text-[10px] text-gray-500">NISM ×2 • IRDAI</span>
            </div>
            
            <div className="absolute bottom-4 right-4 bg-white/95 backdrop-blur px-3 py-1.5 rounded-xl shadow-md border border-gray-200 z-10">
              <span className="text-xs font-bold text-[#16325B] block">Since 2018</span>
              <span className="text-[10px] text-gray-500">in the markets</span>
            </div>
          </div>
        </div>

        {/* Right Content */}
        <div className="lg:col-span-7 space-y-6">
          <span className="text-[11px] font-bold uppercase tracking-widest text-[#16325B] block">
            BUILT BY AN EDUCATOR, NOT A SELLER
          </span>
          <h2 className="font-serif-title text-4xl font-bold text-[#0A2540]">
            Hi, I'm Haritika — trader, investor & financial consultant
          </h2>
          <p className="text-gray-600 text-sm leading-relaxed">
            My journey in the stock market began in 2018 with a simple goal: to understand how money grows through disciplined investing. Since 2021, I've worked professionally with individuals and families — practical strategies, informed decisions, and long-term planning. Successful investing isn't about chasing quick profits; it's consistency, discipline, and the right plan.
          </p>
          <div className="space-y-3 pt-2 text-xs font-semibold text-gray-700">
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-4 h-4 text-[#16325B]" />
              <span>Certified: NISM Equity Derivatives • NISM Mutual Fund Distribution • IRDAI Insurance</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-4 h-4 text-[#16325B]" />
              <span>In the markets since 2018; advising individuals & families since 2021</span>
            </div>
            <div className="flex items-center gap-3">
              <CheckCircle2 className="w-4 h-4 text-[#16325B]" />
              <span>Guidance across stocks, mutual funds, bonds, insurance, PMS, AIF & SIF</span>
            </div>
          </div>

          <div className="pt-2">
            <Link to="/about" className="inline-flex items-center gap-2 text-[#16325B] font-bold text-sm hover:underline">
              Learn with me <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
}